import React from 'react';

import type { Episode } from '~/src/common/lean-back';
import { SeasonEpisodeNumber } from '~/src/components/LeanBack/common-components';
import { useLocale } from '~/src/components/LocaleProvider';

import { durationFormatter } from './durationFormatter';
import { Container } from './elements';

type Props = {
  episode: Episode;
};
export const EpisodeDetails: React.FC<Props> = ({ episode }) => {
  const { locale } = useLocale();

  return (
    <Container>
      <SeasonEpisodeNumber episodeNum={episode.episodeNum()} seasonNum={episode.seasonNum()} />
      <span aria-label="episode duration">
        {durationFormatter({ duration: episode.mediaDuration(), locale })}
      </span>
    </Container>
  );
};
